/**
* Full Page Left Right JS
* -----------------------------------------------------------------------------
*
* All the JS for the Full Page Left Right component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    className: 'full-page-left-right',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      document.querySelectorAll( '.full-page-lr__audio-player' ).forEach( ( player ) => {
        const audio = document.createElement( 'audio' );
        audio.src = player.dataset.audio;
        audio.preload = 'metadata';
        audio.style.display = 'none';
        player.appendChild( audio );

        const playPauseBtn = player.querySelector( '.full-page-lr__play-pause' );
        const playIcon = playPauseBtn.querySelector( '.icon-play' );
        const pauseIcon = playPauseBtn.querySelector( '.icon-pause' );
        const progressWrapper = player.querySelector( '.full-page-lr__progress-wrapper' );
        const progressBar = player.querySelector( '.full-page-lr__progress-bar' );
        const currentTimeEl = player.querySelector( '.full-page-lr__current-time' );
        const durationEl = player.querySelector( '.full-page-lr__duration' );

        const volumeBtn = player.querySelector( '.full-page-lr__volume' );
        const volumeSlider = player.querySelector( '.full-page-lr__volume-slider' );
        const volumeBar = volumeSlider.querySelector( '.full-page-lr__volume-bar' );

        const allPlayers = document.querySelectorAll( '.full-page-lr__audio-player' );

        // Start at 50%
        audio.volume = 0.5;
        volumeBar.style.transform = 'scaleX(0.5)';

        // Play/pause logic
        playPauseBtn.addEventListener( 'click', () => {
          if ( audio.paused ) {
            allPlayers.forEach( ( p ) => {
              if ( p !== player ) {
                const otherAudio = p.querySelector( 'audio' );
                if ( otherAudio && !otherAudio.paused ) {
                  otherAudio.pause();
                  const otherBtn = p.querySelector( '.full-page-lr__play-pause' );
                  otherBtn.querySelector( '.icon-play' ).style.display = 'inline';
                  otherBtn.querySelector( '.icon-pause' ).style.display = 'none';
                }
              }
            } );
            audio.play();
          } else {
            audio.pause();
          }
        } );

        audio.addEventListener( 'play', () => {
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'inline';
        } );

        audio.addEventListener( 'pause', () => {
          playIcon.style.display = 'inline';
          pauseIcon.style.display = 'none';
        } );

        audio.addEventListener( 'loadedmetadata', () => {
          durationEl.textContent = formatTime( audio.duration );
        } );

        audio.addEventListener( 'timeupdate', () => {
          const percent = ( audio.currentTime / audio.duration ) * 100;
          progressBar.style.width = percent + '%';
          currentTimeEl.textContent = formatTime( audio.currentTime );
        } );

        progressWrapper.addEventListener( 'click', ( e ) => {
          const rect = progressWrapper.getBoundingClientRect();
          const percent = ( e.clientX - rect.left ) / rect.width;
          audio.currentTime = percent * audio.duration;
        } );

        // Volume dragging
        let isDragging = false;

        function updateVolume( e ) {
          const rect = volumeSlider.getBoundingClientRect();
          let percent = ( e.clientX - rect.left ) / rect.width;
          percent = Math.min( Math.max( percent, 0 ), 1 );
          audio.volume = percent;
          audio.muted = false;
          volumeBar.style.transform = `scaleX(${percent})`;
        }

        volumeSlider.addEventListener( 'mousedown', () => isDragging = true );
        document.addEventListener( 'mouseup', () => isDragging = false );
        volumeSlider.addEventListener( 'mousemove', ( e ) => {
          if ( isDragging ) updateVolume( e );
        } );
        volumeSlider.addEventListener( 'click', updateVolume );

        // Hover to show slider
        volumeBtn.addEventListener( 'mouseenter', () => {
          volumeSlider.classList.remove( 'hidden' );
          volumeSlider.classList.add( 'flex' );
        } );
        volumeBtn.addEventListener( 'mouseleave', () => {
          if ( !isDragging ) {
            volumeSlider.classList.add( 'hidden' );
            volumeSlider.classList.remove( 'flex' );
          }
        } );

        volumeSlider.addEventListener( 'mouseenter', () => volumeSlider.classList.remove( 'hidden' ) );
        volumeSlider.addEventListener( 'mouseleave', () => {
          if ( !isDragging ) volumeSlider.classList.add( 'hidden' );
        } );

        function formatTime( seconds ) {
          const mins = Math.floor( seconds / 60 );
          const secs = Math.floor( seconds % 60 ).toString().padStart( 2, '0' );
          return `${mins}:${secs}`;
        }
      } );
    },
    finalize: function() {},
  };

  app.registerComponent( 'full-page-left-right', COMPONENT );
} )( app );
